import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { Guid, IApiLink } from "@/types"

export interface IGetAssetLabelGroupDto {
    id: Guid
    labels: string[]
    links: IApiLink[]
}

export default class AssetLabelGroup {
    id: Guid
    labels: string[]
    linkUnlinkLabelFromAsset?: IApiLink
    linkDeleteLabelFromLabelGroup?: IApiLink

    constructor(dto: IGetAssetLabelGroupDto) {
        this.id = dto.id
        this.labels = dto.labels
        this.linkUnlinkLabelFromAsset = dto.links.find(link => link.entity === ApiLinkEntity.labelGroupLink && link.rel === ApiLinkRel.delete)
        this.linkDeleteLabelFromLabelGroup = dto.links.find(link => link.entity === ApiLinkEntity.label && link.rel === ApiLinkRel.delete)
    }
}
